module.exports = "/static/images/Mount-Airy-Chamber.png";